import { CSSProperties, useEffect, useRef } from 'react'
import { Wrapper, MobileContent, DesktopContent } from './HappyHour.styles'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import { useElementClick } from '@/hooks/HTMLElementClickHook'

type HappyHourProps = {
  content: string
  mobileContent?: string
  style?: CSSProperties
}
const HappyHour: React.FC<HappyHourProps> = ({ content, mobileContent, style }) => {
  const mobileRef = useRef<HTMLDivElement>(null)
  const desktopRef = useRef<HTMLDivElement>(null)
  const trackButtonClicked = useElementClick('Link')

  useEffect(() => {
    const handleClick = (e: any) => {
      const target = e.target as HTMLElement

      if (target.tagName === 'A') {
        const href = (target as HTMLAnchorElement).href
        trackButtonClicked({
          location: 'Topbar | Happy Hour',
          text: target.innerText,
          url: href,
          event: e,
        })
      }
    }

    const mobileEl = mobileRef.current
    const desktopEl = desktopRef.current

    mobileEl?.addEventListener('click', handleClick)
    desktopEl?.addEventListener('click', handleClick)

    return () => {
      mobileEl?.removeEventListener('click', handleClick)
      desktopEl?.removeEventListener('click', handleClick)
    }
  }, [])
  // FIXME: using content for both mobile and desktop; mobileContent is coming through incorrectly
  return (
    <Wrapper style={style}>
      {mobileContent && (
        <MobileContent data-testid="happy-hour-mobile" ref={mobileRef}>
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
        </MobileContent>
      )}
      <DesktopContent responsive={!mobileContent} data-testid="happy-hour-desktop" ref={desktopRef}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
      </DesktopContent>
    </Wrapper>
  )
}

export default HappyHour
